import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AG_GRID_LOCALE_FI, AG_GRID_LOCALE_EN, AG_GRID_LOCALE_SE } from '@ag-grid-community/locale'
import { appLanguageSelector } from '../../redux/app/selectors'

export const useAgGridLocale = () => {
  const lng = useSelector(appLanguageSelector)

  const localeText = useMemo(() => {
    switch (lng) {
      case 'fi':
        return AG_GRID_LOCALE_FI
      case 'en':
        return AG_GRID_LOCALE_EN || {}
      case 'sv':
        return AG_GRID_LOCALE_SE || {}
      default:
        return AG_GRID_LOCALE_FI
    }
  }, [lng])

  return localeText
}
